import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';

export const CLOUD_INSIGHTS_BREADCRUMBS = [
  { label: ModuleList.modules.insights.name },
  {
    label: pagesConfig.insightsCloudInsights.name,
    path: `${pagesConfig.insights.link}/${pagesConfig.insightsCloudInsights.link}`,
  },
];
